import { API, axios, SendRequest} from '@/imports-files/pages/admins/dashboard/clients/integration';


export class findJob extends SendRequest 
{
  
  async getJobsData(params) {
    try {
      const result = await axios({
        method: 'get',
        url: API.open.GET_CAREER_PAGE_DATA,
        headers: {},
        params: params,
      });
      return result;
    } catch (error) {
      return error;
    }
  }

  async getJobsDataForClientOwner(params) 
  {
    const url = API.client.career.PAGE_DATA;
    try {
      const result = await axios.get( url,
          {
            params: params,
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());

      return result;
    } catch (error) {
      return error;
    }
  }



  async setJobsImages(params) {

    const url = API.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE;
    try {
      const result = await axios.post( url,
          params,
          this.setMultipartHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());

      return result;
    } catch (error) {
      return error;
    }
  }

  async setJobsInfo(params) 
  {
    const url = API.admins.dashboard.clients.jobs.UPDATE_CAREER_PAGE;
    try {
      const result = await axios.post( url,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());

      return result;
    } catch (error) {
      return error;
    }
  }

  async getIframeJobsData(params) {
    try {
      const result = await axios({
        method: 'get',
        url: API.open.GET_IFRAME_JOBS_DATA,
        headers: {},
        params: params,
      });
      return result;
    } catch (error) {
      return error;
    }
  }
  
}



